module.exports = __webpack_public_path__ + "img/levels_default.ab4e9c21.jpeg";